<template>
  <div class="animated fadeIn">
    <Tables
      ref="tableGrid"
      :columns="['DATA IMPORTAÇÃO','TIPO', 'SITUAÇÃO', 'OBSERVAÇÕES', 'TOTAL LINHAS', 'PROCESSADAS', 'COM ERROS', 'ALERTA', '%', 'TENTANTIVAS', 'AÇÕES']"
      :showUpload="true"
      :showSearch="true"
      :showTipFooter="false"
      :showReload="true"
      v-on:Search="onShowSearch"
      v-on:Upload="onUpload"
      v-on:Load="onLoad"
      v-on:Reload="onLoad"
    >
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn
          :IsTextNoLink="true"
          v-on:Edit="onEdit(obj)"
          :status="1"
          :value="formatDate(obj.dataEnvio)"
        />
        <TableColumn
          :IsTextNoLink="true"
          v-on:Edit="onEdit(obj)"
          :status="1"
          :value="obj.tipoPlanilha"
        />
        <td class="text-center">
          <div v-on:click="onEdit(obj)">
            <span
              v-if="obj.status === 'SUCESSO'"
              class="badge badge-success text-toupper"
            >
              {{obj.status}}
            </span>
            <span
              v-else-if="obj.status === 'AGUARDANDO_PROCESAMENTO'"
              class="badge badge-primary text-toupper"
            >
              {{obj.status}}
            </span>
            <span
              v-else-if="obj.status === 'PROCESSANDO'"
              class="badge badge-info text-toupper"
            >
              {{obj.status}}
            </span>
            <span
              v-else
              class="badge badge-danger text-toupper"
            >
              {{obj.status}}
            </span>
          </div>
        </td>
        <TableColumn
          :IsTextNoLink="true"
          v-on:Edit="onEdit(obj)"
          :status="1"
          :value="obj.observacao"
          classCss="setDisabledLink"
        />
        <TableColumn
          :IsTextNoLink="true"
          v-on:Edit="onEdit(obj)"
          :status="1"
          :value="obj.totalLinhas ? obj.totalLinhas.toString() : '0'"
        />
        <TableColumn
          :IsTextNoLink="true"
          v-on:Edit="onEdit(obj)"
          :status="1"
          :value="obj.linhasProcessadas ? obj.linhasProcessadas.toString() : '0'"
        />
        <TableColumn
          :IsTextNoLink="true"
          v-on:Edit="onEdit(obj)"
          :status="1"
          :value="obj.linhasErro ? obj.linhasErro.toString() : '0'"
        />
        <TableColumn
          :IsTextNoLink="true"
          v-on:Edit="onEdit(obj)"
          :status="1"
          :value="obj.linhasAlerta ? obj.linhasAlerta.toString() : '0'"
        />
        <td class="text-center">
          <div v-on:click="onEdit(obj)" style="width: 100px">
            <b-progress
              :value="obj.linhasProcessadas + obj.linhasErro"
              :max="obj.totalLinhas"
              show-progress
              striped
              :variant="onCalcProcess(obj) < 100 ? '' : 'success'"
            ></b-progress>
          </div>
        </td>
        <TableColumn
          :IsTextNoLink="true"
          v-on:Edit="onEdit(obj)"
          :status="1"
          :value="obj.qtdTentativas ? obj.qtdTentativas.toString() : '0'"
        />
        <td class="row justify-content-around">
          <div v-if="obj.relatorio" @click="showDetails(obj)">
            <i class="fas fa-comment-alt text-third cursor-pointer"></i>
          </div>
          <div v-if="obj.status === 'PROCESSANDO' || obj.status === 'AGUARDANDO_PROCESAMENTO'">
            <b-dropdown variant="link" size="sm" no-caret>
              <template slot="button-content">
                <i class="fas fa-times text-third cursor-pointer" style="color: red;"></i>
              </template>
              <b-dropdown-header>
                <strong>{{$lang.Common.ConfirmCancel}}</strong>
              </b-dropdown-header>
              <b-dropdown-item
                href="javascript:void(0);"
                v-on:click="cancelImport(obj)"
              >
                {{$lang.Common.Yes}}
              </b-dropdown-item>
              <b-dropdown-item href="javascript:void(0);">{{$lang.Common.No}}</b-dropdown-item>
            </b-dropdown>
          </div>
        </td>
      </tr>
    </Tables>
    <div class="row">
      <div class="col-12 pb-3 pl-4">
        <button
          type="button"
          class="btn btn-third btn-sm"
          v-on:click="$emit('Upload')"
          v-b-tooltip.hover
          :title="'Clique para realizar Upload'"
        >
          <i class="fas fa-plus-circle"></i> <span class="d-md-down-none"> Nova Importação</span>
      </button>
      </div>
    </div>
    <b-modal
      ref="modal-details"
      scrollable
      title="Detalhes da Importação"
      size="lg" button-size="sm"
    >
      <div v-if="getMesssage" class="text-center pt-3 pb-3">
        {{getMesssage}}
      </div>
      <div v-else class="text-center pt-5 pb-5">
        Nenhum detalhe encontrado!
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button
            type="button"
            class="btn btn-third btn-sm"
            v-on:click="hideModal"
            v-b-tooltip.hover
            :title="'Fechar detalhes'"
          >
            <i class="fas fa-times-circle"></i><span class="d-md-down-none"> Fechar</span>
          </button>
        </div>
      </template>
    </b-modal>
    <SidebarSearch @search="onSearch" />
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import ImportsRepository from '@/shared/http/repositories/configurations/imports.js'
import SidebarSearch from '@/views/private/import/components/search/SidebarPlanilhas.vue'

const PATH_URL_API = process.env.APIBaseURLCore

export default {
  name: 'ImportList',
  mixins: [ActionsForm],
  data () {
    return {
      errorMessage: null,
      pooling: null,
      data: null,
      form: null,
      filters: null
    }
  },
  components: {
    SidebarSearch
  },
  computed: {
    getMesssage () {
      let result = ''
      if (this.errorMessage) {
        result = this.errorMessage
      }
      return result
    }
  },
  created () {
    // this.onSetRefresh()
  },
  beforeDestroy () {
    clearInterval(this.polling)
  },
  methods: {
    onUpload () {
      this.$emit('Upload')
    },
    onSetRefresh () {
      this.pooling = setInterval(() => {
        this.onLoadAll()
      }, 5000)
    },
    onLoad () {
      this.onLoadAll()
    },
    onLoadAll () {
      loading.push()
      if (this.filters) {
        ImportsRepository.Search(this.createRequestParam(), this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then((response) => {
            this.onResultGrid(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      } else {
        ImportsRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then((response) => {
            this.onResultGrid(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    createRequestParam () {
      let listParam = []
      if (this.filters.tipoPlanilha) listParam.push('tipoPlanilha=' + this.filters.tipoPlanilha)
      if (this.filters.status) listParam.push('status=' + this.filters.status)
      return listParam.join('&')
    },
    onGetReport (obj) {
      ImportsRepository.GetReportShareById(obj.id)
        .then((response) => {
          if (response.status === 200) {
            var data = response.data
            if (data && data.uuid) {
              window.open(`${PATH_URL_API}/arquivos/compartilhados/${data.uuid}/download`)
            }
            /*
            let fileName = obj.tipoPlanilha + '-' + 'RELATORIO.xlsx'
            this.openToDownload(data, fileName)
            */
          }
        })
        .catch(this.onException)
    },
    formatDate (value) {
      let result = ''
      if (value) {
        result = this.moment(value).format('DD/MM/YYYY HH:mm')
      }
      return result
    },
    showModal () {
      this.$refs['modal-details'].show()
    },
    hideModal () {
      this.$refs['modal-details'].hide()
    },
    showDetails (obj) {
      this.onGetReport(obj)
    },
    openToDownload (data, fileName) {
      const fileStartName = this.moment().format('YYYYMMDDhhmm')
      const url = URL.createObjectURL(new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileStartName.toString() + '-' + fileName)
      document.body.appendChild(link)
      link.click()
      link.remove()
      // document.body.removeChild(link)
    },
    base64ToArrayBuffer (base64) {
      let binaryString = window.atob(base64)
      var len = binaryString.length
      var bytes = new Uint8Array(len)
      for (var i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes.buffer
    },
    onCalcProcess (obj) {
      let result = 0
      if (obj) {
        result = parseInt(((obj.linhasProcessadas + obj.linhasErro) / obj.totalLinhas) * 100)
      }
      return result
    },
    onSearch (filters) {
      this.filters = filters
      this.$refs.tableGrid.Clear()
      this.$nextTick(() => {
        this.onLoadAll()
      })
    },
    onShowSearch () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
    },
    cancelImport (obj) {
      loading.push()
      ImportsRepository.CancelImport(obj.id)
        .then((response) => {
          if (response.status === 200) {
            toast.success('Importação cancelada!', 'IMPORTAÇÃO')
            this.onLoadAll()
            loading.pop()
          }
        })
        .catch(this.onException)
    }
  }
}
</script>

<style scoped>
.modal-body {
  background-color: #f8f9fa
}
.setDisabledLink {
  text-decoration: none;
  cursor: default;
  text-align: justify;
}
</style>



// WEBPACK FOOTER //
// src/views/private/import/components/list/importlist.vue